import { FunctionComponent } from "react";
import cx from "classnames";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { Text } from "@smartsuite/react-ui/lib";

export interface SidebarTabProps {
  iconName: string;
  label: string;
  isActive?: boolean;
  onClick: () => void;
}

export const SidebarTab: FunctionComponent<SidebarTabProps> = ({
  iconName,
  label,
  isActive,
  onClick,
}) => {
  const classes = cx("sidebar-tab", { "is-active": isActive });

  return (
    <button className={classes} onClick={onClick}>
      <Icon
        name={iconName}
        color="currentColor"
        className="sidebar-tab__icon"
      />
      <Text size="xs" weight="medium">
        {label}
      </Text>
    </button>
  );
};
